import { dispatch } from '@rematch/core';
import { push } from "react-router-redux";

import { logout as auth0Logout } from "../../services/auth0.js"
import { toastr } from 'react-redux-toastr';

import { app, resendConfirmationService,accountUsersService, captchaCheckService, versionService, accountService, accountUserWorkspacesService, environmentService, userCacheService, ssoConfigService,signUpService, GetMyPlaybooksFromAllAccountsAndWorkspacesService, autoLoginService, autoLoginCompleteService, loginOtpService } from "../../services/feathers.service";


const initialState = {
	loggedIn: false,
	emailId: null,
	confirmationSent: false,
	accessToken: null,
	sendConfirmationError: null,
	bookMarkedAccountId: null,
	fromUrl: null,
	isUnAuthorized: false,
	loggedInUserData: null,
	loginError: null,
	skipAccountCreation: true,
	version: '',
	ssoConfig: null,
	captchaResponse: null,
	captchaEnabled: false,
	pendingVerificationUserId: null,
	pendingVerificationEmail: null,
	otpMode: false,
	otpSent: false,
	otpRequestError: null,
	otpExpiresAt: null,
};
const SSO_PATHID = "aspenify_sso_path";

const checkDefaultAccountAndRedirect = async (userData, accountId, isUnAuthorized, fromUrl, skipAccountCreation) => {
	if (userData.user.accounts && userData.user.accounts.length > 0) {
		if(!skipAccountCreation || userData.user.accounts.some(account => account.role === 'customerAdmin') || userData.user.isPlatformUser){		
			let isPlatformAccountSelected = false;
			for (let index = 0; index < userData.user.accounts.length; index++) {
				if (userData.user.accounts[index].default) { //if user has default account
					dispatch.app.isDefaultSelected(true)
					if (userData.user.accounts[index].role === 'platformAdmin') {
						isPlatformAccountSelected = true;
					}
					accountId = userData.user.accounts[index].id;
					await dispatch.account.selectAccount({ accountId: accountId });
				}
			}
			if (!accountId) {
				if (!fromUrl) {
					dispatch.app.isDefaultSelected(false)
				}

				if (userData.user.accounts[0].role === 'platformAdmin') {
					isPlatformAccountSelected = true;
				}
				accountId = userData.user.accounts[0].id;
				await dispatch.account.selectAccount({ accountId: accountId, isUnAuthorized: isUnAuthorized });
			}

			if (userData.authentication.strategy !== "api-key"){
				if (!userData.user.isVerified) { //Check Account is verified or not
					await dispatch.app.setAllOrganizations({ accountId: accountId, isUnAuthorized: isUnAuthorized });
					return dispatch(push('/updatePassword/' + userData.user._id));
				}
			}

			if (isPlatformAccountSelected) {
				if (userData.user.isPlatformUser) { //Check Platform Admin and redirect to platform URL
					// accountId = userData.user.accounts.filter((account) => { return account.role === 'platformAdmin' })[0].id;
					await dispatch.account.selectAccount({ accountId: accountId, isUnAuthorized: isUnAuthorized });
					return dispatch(push(`app/platform/home`));
				}
			}
			if (isUnAuthorized) {
				await dispatch.login.setIsUnAuthorized(false);
				return dispatch(push(`/app/${accountId}/403`));
			}

			let isDefaultAcc = userData.user.accounts.filter((df, i) => { return df.default && df.role !== "platformAdmin" }).length;
			let isDefaultWorkspace = userData.user.accounts.filter((df, i) => { return df.default }).length;
			let noDefaultAccountSelected = false;
			if (isDefaultAcc === 0 && isDefaultWorkspace === 0 && userData.user.accounts.length > 1) {
				dispatch.account.setViewAccountFlag(true);
				noDefaultAccountSelected = true;
			}

			if (userData.user.isVerified) {
				await dispatch.app.setAllOrganizationsAndRedirectToDefault({ accountId: accountId, isUnAuthorized: isUnAuthorized, noDefaultAccountSelected })
			}

			dispatch.login.setSkipAccountCreation(true);
		} else {
			if (userData.authentication.strategy !== "api-key"){
				if (!userData.user.isVerified) { //Check Account is verified or not
					if (!accountId){
						accountId = userData.user.accounts[0].id;
					}
					await dispatch.app.setAllOrganizations({ accountId: accountId, isUnAuthorized: true });
					return dispatch(push('/updatePassword/' + userData.user._id));
				}
			}
			const userEmail = userData.user.email;
			return dispatch(push(`/createAccount/${userEmail}`));
		}
	} else {
		if (userData.authentication.strategy !== "api-key"){
			if (!userData.user.isVerified) { //Check Account is verified or not
				if (!accountId){
					accountId = userData.user.accounts[0].id;
				}
				await dispatch.app.setAllOrganizations({ accountId: accountId, isUnAuthorized: true });
				return dispatch(push('/updatePassword/' + userData.user._id));
			}
		}
		const userEmail = userData.user.email;
		// app.logout();
		return dispatch(push(`/newuser/${userEmail}`));
	}
}


const checkDefaultAccountAndRedirectForSSO = async (userData, accountId, isUnAuthorized, fromUrl) => {
	if (userData.user.accounts && userData.user.accounts.length > 0) {
		dispatch.app.isDefaultSelected(false);
		accountId = userData.user.accounts[0].id;
		await dispatch.account.selectAccount({ accountId: accountId, isUnAuthorized: isUnAuthorized });

		if (userData.user.isVerified) {

			const query = {
				accountId: accountId,
				accountUserId: userData.user._id,
				$select: [ 'organizations', 'subOrganizations' ]
			}
			const accountUserWorkspaces = await accountUserWorkspacesService.find({
				query
			});



			await dispatch.app.setAllOrganizationsAndRedirectToDefault({ accountId: accountId, isUnAuthorized: isUnAuthorized })
		}

		let isDefaultAcc = userData.user.accounts.filter((df, i) => { return df.default && df.role !== "platformAdmin" }).length;
		let isDefaultWorkspace = userData.user.accounts.filter((df, i) => { return df.default }).length;
		if (isDefaultAcc === 0 && isDefaultWorkspace === 0 && userData.user.accounts.length > 1) {
			dispatch.account.setViewAccountFlag(true);
		}
	} 
}

export default {
	state: {},
	reducers: {
		setError(state, payload) {
			return {
				...state,
				loginError: payload
			}
		},
		setSendConfirmationError(state, payload) {
			return {
				...state,
				sendConfirmationError: payload
			}
		},
		setLoggedIn(state, payload) {
			return {
				...state,
				loggedIn: payload
			}
		},
		setAccessToken(state, payload) {
			return {
				...state,
				accessToken: payload
			}
		},
		setSSOConfig(state, payload) {
			return {
				...state,
				ssoConfig: payload
			}
		},
		setConfirmationSent(state, payload) {
			return {
				...state,
				confirmationSent: true,
				emailId: payload
			}
		},
		setSkipAccountCreation(state, payload) {
			return {
				...state,
				skipAccountCreation: true,
			}
		},
		setBookmarkedAccountId(state, payload) {
			return {
				...state,
				bookMarkedAccountId: payload,
			}
		},
		setFromUrl(state, payload) {
			return {
				...state,
				fromUrl: payload,
			}
		},
		setIsUnAuthorized(state, payload) {
			return {
				...state,
				isUnAuthorized: payload,
			}
		},
		setLoggedInUserData(state, payload) {
			return {
				...state,
				loggedInUserData: payload
			}
		},
		setCaptchaResponse(state, payload) {
			return {
				...state,
				captchaResponse: payload
			}
		},
		setVersion(state, payload) {
			return {
				...state,
				version: payload
			}
		},
		setCaptchaCheck(state, payload) {
			return {
				...state,
				captchaEnabled: payload
			}
		},
		setEmailId(state, payload) {
			return {
				...state,
				emailId: payload
			}
		},
		setPendingVerificationUserId(state, payload) {
			return {
				...state,
				pendingVerificationUserId: payload,
			}
		},
		setPendingVerificationEmail(state, payload) {
			return {
				...state,
				pendingVerificationEmail: payload,
			}
		},
		setOtpMode(state, payload) {
			return {
				...state,
				otpMode: payload,
				otpSent: payload ? state.otpSent : false,
				otpRequestError: null,
			}
		},
		setOtpSent(state, payload) {
			return {
				...state,
				otpSent: payload,
			}
		},
		setOtpRequestError(state, payload) {
			return {
				...state,
				otpRequestError: payload,
			}
		},
		setOtpExpiresAt(state, payload) {
			return {
				...state,
				otpExpiresAt: payload,
			}
		},
		clear() {
			return initialState
		},
	},
	effects: {
		async SignupAsync(payload, rootState) {
			try {
				const response = await signUpService.create(payload);
				if (response.isUserExist) {
					throw new Error('User with this email already exists');
				}
				const userId = response.user._id.toString();
				const email = payload.email;
				sessionStorage.setItem('pendingVerificationUserId', userId);
				sessionStorage.setItem('pendingVerificationEmail', email);
				dispatch.login.setPendingVerificationUserId(userId);
				dispatch.login.setPendingVerificationEmail(email);
				return { success: true, otp: response.otp, userId };
			} catch (error) {
				if (error.message === 'User with this email already exists') {
					throw error;
				}
				throw new Error('An unexpected error occurred during signup');
			}
		},
		async autoLoginWithToken(payload, rootState) {
			const { userId, autoLoginToken } = payload;
			dispatch.app.setUserCache(null);
			dispatch.app.setUserCacheHash(null);
			try {
				const result = await autoLoginService.create({ userId, autoLoginToken });
				const userData = await app.authenticate({
					strategy: 'jwt',
					accessToken: result.accessToken,
				});

				autoLoginCompleteService.create({ userId });

				dispatch.login.setLoggedIn(true);
				dispatch.login.setAccessToken(userData.accessToken);
				await dispatch.app.setUser(userData.user);
				await dispatch.registerAccount.setUserForVerification(userData.user);
				await dispatch.login.setLoggedInUserData(userData);
				await dispatch.account.getAllAccounts();
				await dispatch.login.getEnvData();

				const userCacheObj = await userCacheService.get(userData.user._id);
				await dispatch.app.setUserCache(userCacheObj.obj);
				window.userCacheObj = userCacheObj.obj;

				dispatch.app.isUserLoggedIn(true);
				await this.checkIfAnyPlaybookCreated();

				sessionStorage.removeItem('pendingVerificationUserId');
				sessionStorage.removeItem('pendingVerificationEmail');
				dispatch.login.setPendingVerificationUserId(null);
				dispatch.login.setPendingVerificationEmail(null);

				let accountId;
				await checkDefaultAccountAndRedirect(userData, accountId, false, null, rootState.login.skipAccountCreation);
			} catch (err) {
				console.log(err);
				dispatch.login.setError(err);
			}
		},
		async loginAsync(payload, rootState) {

			localStorage.removeItem(SSO_PATHID);

			const formData = payload.formData;
			const fromUrl = payload.fromUrl;


			dispatch.app.setUserCache(null);
			dispatch.app.setUserCacheHash(null);
			try {
				const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/authentication`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'include',
				body: JSON.stringify({
					strategy: 'local',
					email: formData.email,
					password: formData.password,
					rememberMe: formData.rememberMe 
				})
				});
				const authResult = await response.json();
				if(!response.ok){
					throw new Error(authResult.message || "Invalid Login");
				}
				const userData = await app.authenticate({
				strategy: 'jwt',
				accessToken: authResult.accessToken
				});
				if(userData.user.otp){
					if(payload.otp === userData.user.otp){
					await accountUsersService.patch(userData.user._id, { "isVerified": true, "otp": "" });
					userData.user.isVerified = true;
					userData.user.otp = "";

					} else if (!userData.user.isVerified || payload.otp && payload.otp !== userData.user.otp) {
						toastr.error('Error', 'Please verify your email to continue');
						this.logout();
						return;
					}	
				}

				dispatch.login.setLoggedIn(true);
				dispatch.login.setAccessToken(userData.accessToken);
				await dispatch.app.setUser(userData.user);
				await dispatch.registerAccount.setUserForVerification(userData.user);
				await dispatch.login.setLoggedInUserData(userData);
				await dispatch.account.getAllAccounts();
				await dispatch.login.getEnvData();

				const userCacheObj = await userCacheService.get(userData.user._id);
				await dispatch.app.setUserCache(userCacheObj.obj);
				//await dispatch.app.setUserCacheHash(userCacheObj.hash);
				window.userCacheObj = userCacheObj.obj;

				dispatch.app.isUserLoggedIn(true);
				await this.checkIfAnyPlaybookCreated();
				//set default first account detail in 
				let accountId;
				if (fromUrl) {
					const urlParts = fromUrl.split("/");
					const appIndex = urlParts.indexOf("app");
					let bookMarkedOrgId = null, bookMarkedAccountId = null;
					if (appIndex && appIndex + 1 < urlParts.length) {
						bookMarkedAccountId = urlParts[appIndex + 1];

						const bookMarkedAccounts = userData.user.accounts.filter(account => account.id === bookMarkedAccountId);
						if (bookMarkedAccounts && bookMarkedAccounts.length > 0) {
							let accountDetails = await accountService.get(bookMarkedAccountId,{
								query: {
								  $populate: [
									{
									  path: "users.id",
									  select: "_id firstName lastName profilePic email",
									},
									{
									  path: "integrations.id",
									  select:
										"_id id label image version description createdAt formBuilder",
									},
								  ],
								},
							  });
							await dispatch.app.setSelectedAccountData(accountDetails);
							await dispatch.app.setAllOrganizations({ accountId: accountId })
							if (!userData.user.isVerified) { //Check Account is verified or not
								return dispatch(push('/updatePassword/' + userData.user._id));
							}
							let wsIndex = urlParts.indexOf('_ws');
							if (wsIndex !== -1 && wsIndex + 1 < urlParts.length) {
								bookMarkedOrgId = urlParts[wsIndex + 1];
								const accountUserWorkspaces = await accountUserWorkspacesService.find({
									query: {
										accountId: bookMarkedAccountId,
										accountUserId: userData.user._id
									}
								});

								const bookMarkedOrganizations = accountUserWorkspaces.data[0].organizations.filter(organization => organization.id === bookMarkedOrgId);
								if (bookMarkedOrganizations && bookMarkedOrganizations.length > 0) {
									await dispatch.app.setSelectedOrganisationData(bookMarkedOrganizations[0]);
									return dispatch(push(fromUrl));
								} else {
									await dispatch.login.setBookmarkedAccountId(accountId);
									await dispatch.login.setFromUrl(fromUrl);
									await dispatch.login.setIsUnAuthorized(true);
									await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
								}

							} else {
								return dispatch(push(fromUrl));
							}

						} else {
							if (appIndex !== -1) {
								await dispatch.login.setBookmarkedAccountId(accountId);
									await dispatch.login.setFromUrl(fromUrl);
									await dispatch.login.setIsUnAuthorized(true);
								await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
							} else { //mainly for login page when it is bookmarked. 
								return dispatch(push(fromUrl));
							}
						}
					} else {
						dispatch.app.setCurrentContext("workspace");
						return dispatch(push(fromUrl));
					}
				}
				else {
					await dispatch.login.setBookmarkedAccountId(accountId);
					await checkDefaultAccountAndRedirect(userData, accountId,false, fromUrl,rootState.login.skipAccountCreation);
				}
				


			} catch (err) {
				console.log(err);
        		dispatch.login.setError(err);
			}
		},
		async requestLoginOtpAsync(payload, rootState) {
			const { email } = payload;
			try {
				dispatch.login.setOtpRequestError(null);
				await loginOtpService.create({ email });
				dispatch.login.setOtpSent(true);
				dispatch.login.setOtpExpiresAt(Date.now() + 5 * 60 * 1000);
			} catch (err) {
				dispatch.login.setOtpRequestError(err);
				throw err;
			}
		},
		async resendLoginOtpAsync(payload, rootState) {
			await this.requestLoginOtpAsync(payload, rootState);
		},
		async otpLoginAsync(payload, rootState) {

			localStorage.removeItem(SSO_PATHID);

			const { email, otp, rememberMe, fromUrl } = payload;

			dispatch.app.setUserCache(null);
			dispatch.app.setUserCacheHash(null);
			try {
				const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/authentication`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					credentials: 'include',
					body: JSON.stringify({
						strategy: 'otp',
						email,
						otp,
						rememberMe
					})
				});
				const authResult = await response.json();
				if (!response.ok) {
					throw new Error(authResult.message || "Invalid or expired code");
				}
				const userData = await app.authenticate({
					strategy: 'jwt',
					accessToken: authResult.accessToken
				});

				if (!userData.user.isVerified) {
					await accountUsersService.patch(userData.user._id, { "isVerified": true });
					userData.user.isVerified = true;
				}

				dispatch.login.setLoggedIn(true);
				dispatch.login.setAccessToken(userData.accessToken);
				dispatch.login.setOtpMode(false);
				await dispatch.app.setUser(userData.user);
				await dispatch.registerAccount.setUserForVerification(userData.user);
				await dispatch.login.setLoggedInUserData(userData);
				await dispatch.account.getAllAccounts();
				await dispatch.login.getEnvData();

				const userCacheObj = await userCacheService.get(userData.user._id);
				await dispatch.app.setUserCache(userCacheObj.obj);
				window.userCacheObj = userCacheObj.obj;

				dispatch.app.isUserLoggedIn(true);
				await this.checkIfAnyPlaybookCreated();

				let accountId;
				await dispatch.login.setBookmarkedAccountId(accountId);
				await checkDefaultAccountAndRedirect(userData, accountId, false, fromUrl, rootState.login.skipAccountCreation);
			} catch (err) {
				console.log(err);
				dispatch.login.setError(err);
			}
		},
		async skipAccountCreationAsync (payload, rootState) {
			await checkDefaultAccountAndRedirect(payload.user,payload.accountId,payload.isUnAuthorized,payload.fromUrl,rootState.app.skipAccountCreation);
		},
		async googleLoginAsync(payload, rootState) {
			localStorage.removeItem(SSO_PATHID);
			const idToken = payload.idToken;
			const fromUrl = payload.fromUrl;
			dispatch.app.setUserCache(null);
			dispatch.app.setUserCacheHash(null);
			try {
				const userData = await app.authenticate({
					strategy: 'google',
					accessToken: idToken,
				});
				await dispatch.login.setLoggedIn(true);
				await dispatch.login.setAccessToken(userData.accessToken);
				await dispatch.app.setUser(userData.user);
				await dispatch.login.setLoggedInUserData(userData);
				await dispatch.login.getEnvData();
				const userCacheObj = await userCacheService.get(userData.user._id);
				await dispatch.app.setUserCache(userCacheObj.obj);
				window.userCacheObj = userCacheObj.obj;
				dispatch.app.isUserLoggedIn(true);
				await this.checkIfAnyPlaybookCreated();
				let accountId;
				if (fromUrl) {
					const urlParts = fromUrl.split("/");
					const appIndex = urlParts.indexOf("app");
					let bookMarkedOrgId = null, bookMarkedAccountId = null;
					if (appIndex !== -1 && appIndex + 1 < urlParts.length) {
						bookMarkedAccountId = urlParts[appIndex + 1];
		
						const bookMarkedAccounts = userData.user.accounts.filter(account => account.id === bookMarkedAccountId);
						if (bookMarkedAccounts && bookMarkedAccounts.length > 0) {
							let accountDetails = await accountService.get(bookMarkedAccountId, {
								query: {
									$populate: [
										{
											path: "users.id",
											select: "_id firstName lastName profilePic email",
										},
										{
											path: "integrations.id",
											select: "_id id label image version description createdAt formBuilder",
										},
									],
								},
							});
							await dispatch.app.setSelectedAccountData(accountDetails);
							await dispatch.app.setAllOrganizations({ accountId: accountId });
							if (!userData.user.isVerified) { // Check if account is verified
								return dispatch(push('/updatePassword/' + userData.user._id));
							}
							let wsIndex = urlParts.indexOf('_ws');
							if (wsIndex !== -1 && wsIndex + 1 < urlParts.length) {
								bookMarkedOrgId = urlParts[wsIndex + 1];
								const accountUserWorkspaces = await accountUserWorkspacesService.find({
									query: {
										accountId: bookMarkedAccountId,
										accountUserId: userData.user._id
									}
								});
								const bookMarkedOrganizations = accountUserWorkspaces.data[0].organizations.filter(organization => organization.id === bookMarkedOrgId);
								if (bookMarkedOrganizations && bookMarkedOrganizations.length > 0) {
									await dispatch.app.setSelectedOrganisationData(bookMarkedOrganizations[0]);
									return dispatch(push(fromUrl));
								} else {
									await dispatch.login.setBookmarkedAccountId(accountId);
									await dispatch.login.setFromUrl(fromUrl);
									await dispatch.login.setIsUnAuthorized(true);
									await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
								}
							} else {
								return dispatch(push(fromUrl));
							}
						} else {
							if (appIndex !== -1) {
								await dispatch.login.setBookmarkedAccountId(accountId);
								await dispatch.login.setFromUrl(fromUrl);
								await dispatch.login.setIsUnAuthorized(true);
								await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
							} else { // Mainly for login page when it is bookmarked
								return dispatch(push(fromUrl));
							}
						}
					} else {
						dispatch.app.setCurrentContext("workspace");
						return dispatch(push(fromUrl));
					}
				} else {
					await dispatch.login.setBookmarkedAccountId(accountId);
					await checkDefaultAccountAndRedirect(userData, accountId,false, fromUrl,rootState.login.skipAccountCreation);
				}
			} catch (err) {
				dispatch.login.setError(err);
			}
		},		
		async microftLoginAsync(payload, rootState) {
			localStorage.removeItem(SSO_PATHID);
			const idToken = payload.idToken;
			const fromUrl = payload.fromUrl;
			dispatch.app.setUserCache(null);
			dispatch.app.setUserCacheHash(null);
			try {
				const userData = await app.authenticate({
					strategy: 'microsoft',
					accessToken: idToken,
				});
				await dispatch.login.setLoggedIn(true);
				await dispatch.login.setAccessToken(userData.accessToken);
				await dispatch.app.setUser(userData.user);
				await dispatch.login.setLoggedInUserData(userData);
				await dispatch.login.getEnvData();
				const userCacheObj = await userCacheService.get(userData.user._id);
				await dispatch.app.setUserCache(userCacheObj.obj);
				window.userCacheObj = userCacheObj.obj;
				dispatch.app.isUserLoggedIn(true);
				await this.checkIfAnyPlaybookCreated();
				let accountId;
				if (fromUrl) {
					const urlParts = fromUrl.split("/");
					const appIndex = urlParts.indexOf("app");
					let bookMarkedOrgId = null, bookMarkedAccountId = null;
					if (appIndex !== -1 && appIndex + 1 < urlParts.length) {
						bookMarkedAccountId = urlParts[appIndex + 1];
		
						const bookMarkedAccounts = userData.user.accounts.filter(account => account.id === bookMarkedAccountId);
						if (bookMarkedAccounts && bookMarkedAccounts.length > 0) {
							let accountDetails = await accountService.get(bookMarkedAccountId, {
								query: {
									$populate: [
										{
											path: "users.id",
											select: "_id firstName lastName profilePic email",
										},
										{
											path: "integrations.id",
											select: "_id id label image version description createdAt formBuilder",
										},
									],
								},
							});
							await dispatch.app.setSelectedAccountData(accountDetails);
							await dispatch.app.setAllOrganizations({ accountId: accountId });
							if (!userData.user.isVerified) { // Check if account is verified
								return dispatch(push('/updatePassword/' + userData.user._id));
							}
							let wsIndex = urlParts.indexOf('_ws');
							if (wsIndex !== -1 && wsIndex + 1 < urlParts.length) {
								bookMarkedOrgId = urlParts[wsIndex + 1];
								const accountUserWorkspaces = await accountUserWorkspacesService.find({
									query: {
										accountId: bookMarkedAccountId,
										accountUserId: userData.user._id
									}
								});
								const bookMarkedOrganizations = accountUserWorkspaces.data[0].organizations.filter(organization => organization.id === bookMarkedOrgId);
								if (bookMarkedOrganizations && bookMarkedOrganizations.length > 0) {
									await dispatch.app.setSelectedOrganisationData(bookMarkedOrganizations[0]);
									return dispatch(push(fromUrl));
								} else {
									await dispatch.login.setBookmarkedAccountId(accountId);
									await dispatch.login.setFromUrl(fromUrl);
									await dispatch.login.setIsUnAuthorized(true);
									await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
								}
							} else {
								return dispatch(push(fromUrl));
							}
						} else {
							if (appIndex !== -1) {
								await dispatch.login.setBookmarkedAccountId(accountId);
									await dispatch.login.setFromUrl(fromUrl);
									await dispatch.login.setIsUnAuthorized(true);
								await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
							} else { // Mainly for login page when it is bookmarked
								return dispatch(push(fromUrl));
							}
						}
					} else {
						dispatch.app.setCurrentContext("workspace");
						return dispatch(push(fromUrl));
					}
				} else {
					await dispatch.login.setBookmarkedAccountId(accountId);
					await checkDefaultAccountAndRedirect(userData, accountId,false, fromUrl,rootState.login.skipAccountCreation);
				}
			} catch (err) {
				dispatch.login.setError(err);
			}
		},
		async loginSSO(payload, rootState) {

			const formData = payload.formData;
			const fromUrl = payload.fromUrl;

			dispatch.app.setUserCache(null);
			dispatch.app.setUserCacheHash(null);
			try {
				const userData = await app.authenticate(payload);

				dispatch.login.setLoggedIn(true);
				dispatch.login.setAccessToken(userData.accessToken);
				
				await dispatch.app.setUser(userData.user);
				await dispatch.login.setLoggedInUserData(userData);
				await dispatch.login.getEnvData();

				const userCacheObj = await userCacheService.get(userData.user._id);
				await dispatch.app.setUserCache(userCacheObj.obj);
				//await dispatch.app.setUserCacheHash(userCacheObj.hash);
				window.userCacheObj = userCacheObj.obj;

				dispatch.app.isUserLoggedIn(true);
				await this.checkIfAnyPlaybookCreated();
				//set default first account detail in 
				let accountId;
				if (fromUrl) {
					const urlParts = fromUrl.split("/");
					const appIndex = urlParts.indexOf("app");
					let bookMarkedOrgId = null, bookMarkedAccountId = null;
					if (appIndex && appIndex + 1 < urlParts.length) {
						bookMarkedAccountId = urlParts[appIndex + 1];

						const bookMarkedAccounts = userData.user.accounts.filter(account => account.id === bookMarkedAccountId);
						if (bookMarkedAccounts && bookMarkedAccounts.length > 0) {
							let accountDetails = await accountService.get(bookMarkedAccountId,{
								query: {
								  $populate: [
									{
									  path: "users.id",
									  select: "_id firstName lastName profilePic email",
									},
									{
									  path: "integrations.id",
									  select:
										"_id id label image version description createdAt formBuilder",
									},
								  ],
								},
							  });
							await dispatch.app.setSelectedAccountData(accountDetails);
							await dispatch.app.setAllOrganizations({ accountId: accountId })
							if (!userData.user.isVerified) { //Check Account is verified or not
								return dispatch(push('/updatePassword/' + userData.user._id));
							}
							let wsIndex = urlParts.indexOf('_ws');
							if (wsIndex !== -1 && wsIndex + 1 < urlParts.length) {
								bookMarkedOrgId = urlParts[wsIndex + 1];
								const accountUserWorkspaces = await accountUserWorkspacesService.find({
									query: {
										accountId: bookMarkedAccountId,
										accountUserId: userData.user._id
									}
								});

								const bookMarkedOrganizations = accountUserWorkspaces.data[0].organizations.filter(organization => organization.id === bookMarkedOrgId);
								if (bookMarkedOrganizations && bookMarkedOrganizations.length > 0) {
									await dispatch.app.setSelectedOrganisationData(bookMarkedOrganizations[0]);
									return dispatch(push(fromUrl));
								} else {
									await dispatch.login.setBookmarkedAccountId(accountId);
									await dispatch.login.setFromUrl(fromUrl);
									await dispatch.login.setIsUnAuthorized(true);
									await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
								}

							} else {
								return dispatch(push(fromUrl));
							}

						} else {
							if (appIndex !== -1) {
								await dispatch.login.setBookmarkedAccountId(accountId);
									await dispatch.login.setFromUrl(fromUrl);
									await dispatch.login.setIsUnAuthorized(true);
								await checkDefaultAccountAndRedirect(userData, accountId, true, fromUrl,rootState.login.skipAccountCreation);
							} else { //mainly for login page when it is bookmarked. 
								return dispatch(push(fromUrl));
							}
						}
					} else {
						dispatch.app.setCurrentContext("workspace");
						return dispatch(push(fromUrl));
					}
				}
				else {
					await dispatch.login.setBookmarkedAccountId(accountId);
					await checkDefaultAccountAndRedirect(userData, accountId,false, fromUrl,rootState.login.skipAccountCreation);
				}    
				
			} catch (err) {
				dispatch.login.setError(err);
			}
		},

		async logout(payload,state) {
			const ssoConfig = {...state.app.ssoConfig};
			window.location.href = "/login";
			await app.logout();
			await dispatch.app.logout(ssoConfig);
			dispatch.app.clear();
			dispatch.login.clear();
			dispatch.invite.clear();
			dispatch.register.clear();
			dispatch.profile.clear();
			dispatch.forgot.clear();
			dispatch.reset.clear();
			dispatch.organizationUnit.clear();
			dispatch.organizationTab.clear();
			dispatch.community.clear();
			dispatch.users.clear();
			dispatch.lifeCycle.clear();
			dispatch.content.clear(true);
			dispatch.createPack.clear();
			dispatch.notifications.clear();
			dispatch.initiatives.clear();
			dispatch.account.clear();
			dispatch.account.setDeActivateAccountModal(false);
			const pathId = localStorage.getItem(SSO_PATHID);
			localStorage.clear();
			if (pathId){
				dispatch(push(`/sso/${pathId}`));
			}

		},

		async getVersion() {
			const versionData = await versionService.find();
			dispatch.login.setVersion(versionData.version);
		},
		async getSSOConfig(configId) {
			const configData = await ssoConfigService.getByConfigId(configId);
			dispatch.login.getSSOConfig(configData);
		},
		async captchaCheck() {
			const captchaData = await captchaCheckService.find();
			dispatch.login.setCaptchaCheck(captchaData.isCaptchaEnabled === 'true');
		},
		async resendConfirmationAsync(payload, rootState) {
			const confirmationObj = {
				emailId: rootState.login.loginError.data.email,
				captchaResponse: rootState.login.captchaResponse
			}
			try {
				await resendConfirmationService.create(confirmationObj);
				dispatch.login.setConfirmationSent(payload);
			} catch (err) {
				dispatch.login.setSendConfirmationError(err);
				throw err;
			}
		},
		async getEnvData() {
			const envData = await environmentService.find();
			dispatch.app.setEnvData(envData);
			// dispatch.app.setHelpContentData();
		},
		async checkIfAnyPlaybookCreated(){
			let createdPlaybooks = await GetMyPlaybooksFromAllAccountsAndWorkspacesService.find();
			// if(createdPlaybooks && createdPlaybooks.length>0){
			// 	localStorage.setItem('showUiTour', 'false');
			// } else {
			// 	localStorage.setItem('showUiTour', 'true');
			// }
		}
	}
}